/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { BoardEarnObjective } from './BoardEarnObjective';
import {
    BoardEarnObjectiveFromJSON,
    BoardEarnObjectiveFromJSONTyped,
    BoardEarnObjectiveToJSON,
    BoardEarnObjectiveToJSONTyped,
} from './BoardEarnObjective';

/**
 * 
 * @export
 * @interface BoardEarnObjectivesResponse
 */
export interface BoardEarnObjectivesResponse {
    /**
     * 
     * @type {Array<BoardEarnObjective>}
     * @memberof BoardEarnObjectivesResponse
     */
    objectives: Array<BoardEarnObjective>;
}

/**
 * Check if a given object implements the BoardEarnObjectivesResponse interface.
 */
export function instanceOfBoardEarnObjectivesResponse(value: object): value is BoardEarnObjectivesResponse {
    if (!('objectives' in value) || value['objectives'] === undefined) return false;
    return true;
}

export function BoardEarnObjectivesResponseFromJSON(json: any): BoardEarnObjectivesResponse {
    return BoardEarnObjectivesResponseFromJSONTyped(json, false);
}

export function BoardEarnObjectivesResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): BoardEarnObjectivesResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'objectives': ((json['objectives'] as Array<any>).map(BoardEarnObjectiveFromJSON)),
    };
}

export function BoardEarnObjectivesResponseToJSON(json: any): BoardEarnObjectivesResponse {
    return BoardEarnObjectivesResponseToJSONTyped(json, false);
}

export function BoardEarnObjectivesResponseToJSONTyped(value?: BoardEarnObjectivesResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'objectives': ((value['objectives'] as Array<any>).map(BoardEarnObjectiveToJSON)),
    };
}

